import { render, staticRenderFns } from "./TrainerDesignation.vue?vue&type=template&id=0e4505fa&"
import script from "./TrainerDesignation.vue?vue&type=script&lang=js&"
export * from "./TrainerDesignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports